import { AutogenLayoutRenditionTypes } from "./autogen/AutogenLayoutRenditionTypes";
import {  DataSourceExecutionEvent } from "@mcleod/components";

export class RenditionTypes extends AutogenLayoutRenditionTypes {

}
